<template>
  <v-sheet>
    <v-card>
      <v-card-title><h2>Nowa akcja</h2></v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">

            <v-select v-model="subscriberSelected" label="Rodzaj akcji"
                      :items="subscriberTypes"
                      @change="model={}"
                      item-text="description"
                      item-value="name"
            ></v-select>

            <v-select v-model="eventType" label="Wydarzenie"
                      v-if="subscriberSelected"
                      :items="EventActionType
                      .getEventsToSelect(subscriberTypes.find(el => el.name == subscriberSelected).properties.allowedEvents)"
                      item-text="name"
                      item-value="value"
            ></v-select>

            <div v-for="(field,key) in getActionFields(subscriberSelected)" :key="'action-field-' + key">
              <v-select v-model="model[field.name]"
                        v-if="field.type=='select'"
                        :label="field.description"
                        :items="field.options"
              ></v-select>

              <v-select v-model="model[field.name]"
                        v-else-if="field.type=='fieldOrder'"
                        :label="field.description"
                        :items="getFields()"
                        item-text="name"
                        item-value="order"
              ></v-select>

              <v-select v-else-if="field.type=='fieldOrders'"
                        v-model="model[field.name]"
                        :items="getFields()"
                        :label="field.description"
                        multiple
                        item-text="name"
                        item-value="order"
              ></v-select>

              <v-select v-model="model[field.name]"
                        v-else-if="field.type=='relatedFieldOrder'"
                        :label="field.description"
                        :items="getFields('related')"
                        item-text="name"
                        item-value="order"
              ></v-select>

              <v-select v-else-if="field.type=='teams'"
                        v-model="model[field.name]"
                        :items="teams"
                        :label="field.description"
                        item-text="name"
                        item-value="id"
                        multiple
              ></v-select>

              <v-select v-else-if="field.type=='schemaId'"
                        v-model="model[field.name]"
                        :items="schemas"
                        :label="field.description"
                        item-text="name"
                        item-value="id"
                        @change="schemaChanged($event)"
              ></v-select>

              <v-select v-else-if="field.type=='foreignFieldOrder'"
                        v-model="model[field.name]"
                        :items="foreignFields"
                        :label="field.description"
                        item-text="name"
                        item-value="order"
              ></v-select>

              <v-select v-else-if="field.type=='tableFieldId'"
                        v-model="model[field.name]"
                        :items="tableFields"
                        :label="field.description"
                        item-text="name"
                        item-value="id"
              ></v-select>

              <v-checkbox v-model="model[field.name]"
                        v-else-if="field.type=='checkbox'"
                        :label="field.description"
              ></v-checkbox>

              <v-select v-model="model[field.name]"
                        v-else-if="field.type=='templateId'"
                        :label="field.description"
                        :items="templates"
                        item-text="name"
                        item-value="id"
              ></v-select>

              <v-menu v-else-if="field.type=='color'" offset-y>
                <template v-slot:activator="{ on }">
                  <div :style="getColorIconStyle(model[field.name])"></div>
                  <v-text-field v-model="model[field.name]" class="schema-name-input" label="Kolor"
                                v-on="on"></v-text-field>
                </template>

                <v-container style="background-color: #ffffff">
                  <color-picker v-bind="model[field.name]"
                                @input="(hue) => onInput(hue, hex => model[field.name] = hex)"/>
                </v-container>
              </v-menu>

              <v-text-field v-else :type="getInputType(field.type)" :label="field.description" v-model="model[field.name]"></v-text-field>

            </div>

            <v-btn @click="submit()">Ok</v-btn>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import eventActionType from "../../../enums/eventActionType"
import ColorPicker from '@radial-color-picker/vue-color-picker'

import color from "@/mixins/color"

export default {
  mixins: [color],
  props: ['subscriberTypes', 'schema', 'templates'],
  components: {ColorPicker},
  data() {
    return {
      subscriberSelected: null,
      model:{},
      foreignSchema: {},
      schemas: [],
      eventType: null,
      EventActionType: eventActionType
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    },
    foreignFields() {
      if (!this.foreignSchema || this.foreignSchema == undefined) {
        return []
      }

      return this.getFields(false, this.foreignSchema.fields)
    },
    tableFields() {
      return this.getTableFields(this.schema.fields)
    },
    fields() {
      return this.getAllFields(this.schemaFields)
    }
  },
  created() {
    this.$http.get('/schemas').then(data => {
      this.schemas = data.data
    })
  },
  methods: {
    schemaChanged(id) {
      this.$http.get(`/schema/${id}`).then(data => {
        this.foreignSchema = data.data
      })
    },
    getFields(type, fields) {
      let fieldsToFilter = fields != undefined ? fields : this.schema.fields
      return fieldsToFilter.filter(field => field.type != 'table' && type ? field.type == type : true)
    },
    getAllFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getTableFields(fieldsToFilter) {
      let fields = []
      fieldsToFilter.forEach(field => {
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    },
    getInputType(type){
      switch (type){
      case "integer" :
        return "number"
      case "relatedValueKey" :
        return "number"
      default :
        return "text"
      }
    },
    getActionPropertyDescription(actionType, propertyName){
      let action = this.subscriberTypes.find(el => el.name == actionType)
      let property = action ? action.properties.fields.find(el => el.name == propertyName) : null
      return property ? property.description : "Nieznana własciwość"
    },
    getActionFields(type){
      let action = this.subscriberTypes.find(el => el.name == type)
      return action ? action.properties.fields : []
    },
    submit() {
      if (!this.eventType || !this.subscriberSelected) {
        return
      }

      let postData = {
        'subscriber': this.subscriberSelected,
        'event': this.eventType,
        'data': this.model
      }
      this.$http.post(`schema/${this.$route.params.schemaId}/subscriber`, postData).then(data => {
        this.$emit('subscriberCreated',data.data)
        this.$store.commit('setSnack', {
          message: "Dodano akcje",
          color: 'success'
        })

        // this.$router.push({name: 'schema-related-map', params: {schemaId: this.$route.params.schemaId}})
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Nie można dodać akcji",
          color: 'error'
        })
      })
    },
  },
}
</script>
<style>
@import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
</style>
